/**
 * 模版市场-盒子组件
 * @author VenDream
 * @since 18/06/07
 */
import clone from '@fe/common/lib/clone';
import { getDeviceInfo } from '@fe/common/lib/device';
import { parse } from '@fe/common/lib/query-string';
import Stat from '@fe/common/lib/stat';
import { default as classnames, default as cx } from 'classnames';
import GameBox from 'components/store-tpl-box/game-box';
import LikeBtn from 'components/store-tpl-box/like-btn';
import TplCover from 'components/store-tpl-box/tpl-cover';
import TplInfo from 'components/store-tpl-box/tpl-info';
import VideoBox from 'components/store-tpl-box/video-box';
import STAT_PARAMS from 'constants/stat-params.json5';
import USER_STATE from 'constants/user-state.json5';
import VARIABLES from 'constants/variable.json5';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { flyTo } from 'utils/animation';
import { sendStat } from 'utils/common';
import * as statisticSDK from 'utils/statisticSDK';
import './store-tpl-box.less';
// 常规H5作品宽高比
const RATIO = 320 / 504;

class StoreTplBox extends Component {
  static propTypes = {
    tpl: PropTypes.object,
    user: PropTypes.object,
    filters: PropTypes.object,
    category: PropTypes.string,
    showModal: PropTypes.func,
    setTplCollectionStatus: PropTypes.func,
    /** 是否有顶部免费标签 */
    hasTopFreeTag: PropTypes.bool,
    /** 是否隐藏顶部栏 */
    hideBottom: PropTypes.bool,
    tplCornerLabelObj: PropTypes.object,
  };

  state = {
    // 是否显示二维码背景
    showQrCode: false,
  };

  componentDidMount() {
    this.box && this.forceUpdate();

    //添加浏览器和系统信息
    window.userStatus = 0;
    if (window.userInfo) {
      window.userStatus = this.getUserStatus(window.userInfo.createtime);
    }
    window.browserInfo = {
      os: this.getBrowserInfo().os,
      browserVersion: this.getBrowserInfo().browserVersion,
    };
  }

  componentWillReceiveProps(nextProps) {
    // 显示收藏状态变更提示
    if (
      this.likeTips &&
      this.props.tpl &&
      this.props.tpl.isCollectionTpl !== undefined
    ) {
      const { id, isCollectionTpl } = this.props.tpl;
      const newTpl = nextProps.tpl;
      if (id === newTpl.id && isCollectionTpl !== newTpl.isCollectionTpl) {
        this.likeTips.style.display = 'block';
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.likeTips && (this.likeTips.style.display = 'none');
        }, 2000);
      }
    }
  }

  // 渲染场景作品及一页作品
  getTplBox() {
    if (!this.box) return null;

    const { category, hasTopFreeTag, hideBottom } = this.props;
    const { id, type, cover, height, width, hotSort } = this.props.tpl;
    const isEnterprise = category === VARIABLES.ENTERPRISE;
    // 计算宽高
    const w = this.box.parentNode.getBoundingClientRect().width - 2;

    const posterRatio = height && width ? width / height : null;
    const currentRatio =
      type === VARIABLES.POSTER && !!posterRatio ? posterRatio : RATIO;
    const h = Math.floor(w / currentRatio);
    const coverStyle = {
      width: w,
      height: h,
    };
    const infoStyle = {
      width: w,
      height: `calc(100% - ${h}px)`,
    };

    // 是否显示企业专区模板置顶角标
    const isShowOrgTopTag = isEnterprise && +hotSort > 0;

    return (
      <div
        className={`tpl-box ${type || ''}`}
        data-tpl-id={id}
        onClick={this.handleClickBox}>
        {isShowOrgTopTag && <span className="org-top-tag">置顶</span>}
        {hasTopFreeTag && (
          <span className="top-free-tag">
            <i className="s-icon icon-label" />
            <span className="free-text">免费</span>
          </span>
        )}
        <TplCover style={coverStyle} cover={cover} category={category} />
        <div
          className={classnames('qrcode-bg', {
            'show-qrcode': this.state.showQrCode,
          })}
          style={coverStyle}
        />
        <TplInfo
          style={infoStyle}
          tpl={this.props.tpl}
          filters={this.props.filters}
          hideBottom={hideBottom}
          isEnterprise={isEnterprise}
          onShowQrCode={this.handleQrCodeBg.bind(this, true)}
          onHideQrCode={this.handleQrCodeBg.bind(this, false)}
        />
      </div>
    );
  }

  // 显示/隐藏二维码盒子蒙层
  handleQrCodeBg = isShow => {
    this.setState({ showQrCode: isShow });
  };

  /**
   * 获取用户状态：status：0新用户，status：1老用户
   */
  getUserStatus = date => {
    return Date.now() - this.getMillisecond(date) / 3600000 >= 24 ? 1 : 0;
  };

  /**
   * 格式化时间为yy/mm/dd hh:mm:ss
   * @param date 传入标准时间
   */
  renderTime = date => {
    return new Date(+new Date(new Date(date).toJSON()) + 8 * 3600 * 1000)
      .toISOString()
      .replace(/T/g, ' ')
      .replace(/\.[\d]{3}Z/, '');
  };

  /**
   * 转换为毫秒
   * @param date 传入的yy/mm/dd hh:mm:ss时间
   */
  getMillisecond = date => {
    return new Date(
      this.renderTime(date).replace(new RegExp('-', 'gm'), '/')
    ).getTime();
  };

  /**
   * 浏览器版本
   */
  getBrowserInfo = () => {
    return {
      os: getDeviceInfo().os.name + ' ' + getDeviceInfo().os.version,
      browserVersion:
        getDeviceInfo().browser.name + ' ' + getDeviceInfo().browser.version,
    };
  };

  // 点击模版盒子
  handleClickBox = () => {
    const { id, type, minimumPrice } = this.props.tpl;
    const { category, filters } = this.props;
    const {
      RP_VIDEO,
      PREVIEW_MODAL,
      PREVIEW_VIDEO_MODAL,
      RP_GAME,
      PREVIEW_GAME_MODAL,
    } = VARIABLES;
    let previewCategory = category;
    if (previewCategory === VARIABLES.MY_TPL && filters.myTplType !== '2') {
      previewCategory = VARIABLES.MY_COLLECTION;
    }

    // 统计模板点击量
    const statData = {
      id: 'web_mobanmarket_moban_click',
      tplid: id,
      tpltype: STAT_PARAMS.TPL_TYPE[type],
      tplprice: minimumPrice ? '2' : '1',
      clickfrom: STAT_PARAMS.TPL_CATEGORY[category],
      os: this.getBrowserInfo().os,
      browserVersion: this.getBrowserInfo().browserVersion,
      userStatus: window.userStatus,
      url: window.location.href,
      tpl_id: this.props.tpl.id,
    };
    // 检查是否在专题页
    const topicid = parse(location.search).id;
    if (topicid) {
      statData.clickfrom = '8';
      statData.topicid = topicid;
    }
    sendStat('RP_STORE', '模版市场', '模版点击', Stat.ACTION_CLICK, statData);

    // fibo埋点，不是小游戏模板的，点击立即使用（或点击模板盒子）发送埋点数据
    if (category !== VARIABLES.RP_GAME) {
      const { tplPrice, title, pluginId } = this.props.tpl;
      let content = `${title}`;
      // 由于在模板市场-推荐页面的时候，返回的模板数据中 category 为空字符串，
      // 所以这里需要加一个判断 pluginId 不存在的情况才能确定不是插件模板
      if (category !== VARIABLES.CHAJIAN && !pluginId) {
        // 由于会员专区返回的数据中 tplPrice 为 null，所以增加 tplPrice === null 的判断
        const isFree = tplPrice === 0 || tplPrice === null;
        const price = isFree ? '免费' : '付费';
        content = `${title}-${price}`;
      }
      statisticSDK.pushCustomEvent('c_click', {
        c_elmname: '立即使用',
        c_elmcontent: content,
        c_money: '',
        c_elmtype: 'button',
        c_component: 'Template',
      });
    }

    // 弹出预览窗口
    this.props.showModal({
      modalType:
        type === RP_VIDEO
          ? PREVIEW_VIDEO_MODAL
          : type === RP_GAME
          ? PREVIEW_GAME_MODAL
          : PREVIEW_MODAL,
      modalProps: {
        presetData: {
          id,
          type,
          category: previewCategory,
        },
      },
    });
  };

  // 点击收藏按钮
  handleClickLikeBtn = like => {
    const { userId, organizeId } = this.props.user;
    const { id, title, tplPrice, isCollectionTpl } = this.props.tpl;

    // 未登陆用户提示登录
    if (!userId) {
      const showSSODialog = window.COMMON_NAVBAR.showSSODialog;
      showSSODialog && showSSODialog('login', true);
      return;
    }
    if (!isCollectionTpl) {
      like.setAttribute('class', 's-icon icon-collect2');
      flyTo(like, document.querySelector('.nav-collection'), {
        toFixed: true,
        initStyle: {
          color: '#ff4534',
        },
      });
    }
    this.props.setTplCollectionStatus(userId, organizeId, id, !isCollectionTpl);
    statisticSDK.pushFiboTemplateCollect({
      type: !isCollectionTpl,
      title,
      tplPrice,
    });
  };

  // hover模版盒子
  handleHoverBox = (e, operation) => {
    const target = e.currentTarget;
    const tplBox = target.querySelector('.tpl-box');

    if (tplBox) {
      if (operation === 'show') {
        tplBox.classList.add('hover');
      } else {
        tplBox.classList.remove('hover');
      }
    }
  };

  // 渲染角注
  renderTagger() {
    const { tpl, tplCornerLabelObj, hasTopFreeTag } = this.props;
    const { filterItems } = tpl;
    let cornerList = [];
    let cornerBlock;
    let copyTplCornerLabelObj = clone(tplCornerLabelObj, true);
    if (copyTplCornerLabelObj) {
      copyTplCornerLabelObj.NEW_TOP10 = '新品TOP10';
      copyTplCornerLabelObj.RECOMMEND_TOP10 = '推荐TOP10';
      copyTplCornerLabelObj.FIRST_AWARD = '设计一等奖';
      copyTplCornerLabelObj.SECOND_AWARD = '设计二等奖';
      copyTplCornerLabelObj.THIRD_AWARD = '设计三等奖';
    }
    //老接口、新接口共用组件
    // 优惠
    const promotion = tpl.promotion ? `减${tpl.promotion.toFixed(2)}元` : '';

    // 折扣
    const discount = tpl.tplDiscountRatio
      ? `${(tpl.tplDiscountRatio * 10).toFixed(1)}折`
      : tpl.discountRatio
      ? `${(tpl.discountRatio * 10).toFixed(1)}折`
      : '';
    // 角注
    try {
      if (
        JSON.stringify(copyTplCornerLabelObj) !== '{}' &&
        JSON.stringify(filterItems) !== '{}'
      ) {
        for (const [key] of Object.entries(copyTplCornerLabelObj)) {
          for (const v of Object.values(filterItems)) {
            if (v.replace(/(^\[*)|(\]*$)/g, '') === key) {
              cornerList.push(key);
            }
          }
        }
      }

      cornerBlock = cornerList.map(item => (
        <span className="tagger-item recommend" key={item}>
          {copyTplCornerLabelObj[item]}
        </span>
      ));
    } catch (error) {
      cornerBlock = null;
    }

    return (
      //海报角标会重叠、特殊处理
      <div
        className={cx('tagger-list', {
          'poster-tagger': tpl.type === 'POSTER' && hasTopFreeTag,
        })}>
        {promotion ? (
          <span className="tagger-item promotion">{promotion}</span>
        ) : null}
        {discount ? (
          <span className="tagger-item discount">{discount}</span>
        ) : null}
        {cornerBlock}
      </div>
    );
  }

  render() {
    const { tpl, category, filters } = this.props;
    // 收藏操作提示
    const tips = tpl.isCollectionTpl ? '收藏成功' : '已取消收藏';
    // 是否企业专区
    const isOrgTab = category === VARIABLES.ENTERPRISE;
    // 是否我使用过的模版
    const isMyUsedTab = filters && filters.myTplType === '2';
    // 是否展示收藏状态(小游戏下不展示)
    const isShowCollectionStatus =
      !isOrgTab && !isMyUsedTab && tpl.type !== VARIABLES.RP_GAME;
    // 具体模版盒子(根据type判断对应盒子)
    let box;
    switch (tpl.type) {
      case VARIABLES.RP_VIDEO: {
        // 系统封禁用户，不触发一视模板预览
        // @since 2019-9-19
        const isSystemDisabled =
          +this.props.user.disabledState === +USER_STATE.SYSTEM_DISABLE;
        box = (
          <VideoBox
            tpl={tpl}
            container={this.box}
            onClickBox={this.handleClickBox}
            isSystemDisabled={isSystemDisabled}
          />
        );
        break;
      }
      case VARIABLES.RP_GAME:
        box = (
          <GameBox
            tpl={tpl}
            container={this.box}
            onClickBox={this.handleClickBox}
          />
        );
        break;
      default:
        box = this.getTplBox();
        break;
    }
    // 盒子类名
    const boxCls = classnames({
      cmp: 1,
      'store-tpl-box': 1,
      'org-tpl-box': isOrgTab,
      'my-used-tpl-box': isMyUsedTab,
      'promotional-tpl-box': isShowCollectionStatus && tpl.promotion,
      'discount-tpl-box':
        isShowCollectionStatus &&
        tpl.tplDiscountRatio &&
        tpl.tplDiscountRatio < 1,
      'recommend-tpl-box': tpl.filterItems && tpl.filterItems.tplTop10,
      'award-tpl-box': tpl.filterItems && tpl.filterItems.tplCornerLabel,
      transitionable: 1,
    });

    return (
      <div
        className={boxCls}
        onMouseEnter={e => this.handleHoverBox.call(this, e, 'show')}
        onMouseLeave={e => this.handleHoverBox.call(this, e, 'hide')}
        ref={node => (this.box = node)}>
        {/* <div
          className="tagger"
          data-promotion={promotion}
          data-discount={discount}
        /> */}
        {this.renderTagger()}
        {isShowCollectionStatus ? (
          <div
            className="tpl-like-operation-tips"
            ref={node => (this.likeTips = node)}>
            {tips}
          </div>
        ) : null}
        {isShowCollectionStatus ? (
          <LikeBtn
            isLiked={tpl.isCollectionTpl}
            onClickBtn={this.handleClickLikeBtn}
          />
        ) : null}
        {box}
      </div>
    );
  }
}

export default StoreTplBox;
